module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17kZxjT/images/cover.jpg?1685327317425",
      "alt": "This image is the cover for the book Exodus, Heaven Corp"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Exodus, Heaven Corp\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Heaven Corp: Book Two")])])]), _c('p', [_vm._v("Henry “Hank” Abraham’s privileged status in the floating city of Heaven lets him flout Morality Laws that control the lives of others. But when he wakes up in the arms of another stranger, only bodyguard Ian Caldwell’s quick thinking saves his life.")]), _vm._v(" "), _c('p', [_vm._v("Though Ian’s from the low levels and the labor class, he’s used to dealing with the pampered society of Heaven. He’s assigned to protect Hank while angels, cybernetically modified humans who defend Heaven, investigate the assassination attempt. Doing his job means Ian must ignore his growing interest in Hank. Acting on their mutual attraction would certainly get Ian reprogrammed, something neither of them can afford.")]), _vm._v(" "), _c('p', [_vm._v("When Hank follows Ian to a popular BDSM club in Downside and his ID chip is lost during a nearly fatal mugging, he finds himself locked out of Heaven. As Ian fights to get them home, rumors of impending war begin to circulate—along with more troubling news that Ian is wanted for Hank’s murder. While struggling to keep the man he has come to love safe, Ian must find out who’s behind the plot and if it’s a catalyst for war or just a convenient excuse.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      CC Bridges\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0